import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Button } from '@material-ui/core';

//helpers:
import { getData } from '../../dataLib';

//components
import NeuriteGrid from '../../components/neurite_grid';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    button: {
        margin: '15px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    }
});

class SelectMaquina extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            maquinaSelected: undefined,
            showSpinner: true,
            rows: []
        };
    }

    componentDidMount = () => {
        this.getMaquinas(this.props.centroId);
    }


    getMaquinas = (centro_id) => {

        let maqURL = 'VMaquinas/VMaquinasAlta?centro_id=' + centro_id;

        getData(maqURL,
            (response) => {
                this.setState({ ...this.state, rows: response.data, showSpinner: false })
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR obteniendo las máquinas de este centro'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };

    onMaquinaSelected = (maquina, column) => {
        this.setState({ ...this.state, maquinaSelected: maquina });
    }


    render() {

        const { classes } = this.props;

        return (
            this.state.showSpinner ?
                <div style={{ textAlign: "center" }}>
                    <CircularProgress className={classes.spinner} color="primary" />
                </div>
                :
                <div>
                    <NeuriteGrid
                        id="s_m"
                        columns={[
                            { key: 'descr', name: 'Nombre', editable: false, dragable: false, width: 120 },
                            { key: 'modelo', name: 'Modelo', editable: false, dragable: false, width: 120 },
                            { key: 'matricula', name: 'Matricula', editable: false, dragable: false, width: 120 },
                            { key: 'regInterno', name: 'Registro interno', editable: false, dragable: false, width: 120 }
                        ]}
                        rows={this.state.rows}
                        height={300}
                        buttonEdit={false}
                        buttonDelete={false}
                        buttonNew={false}
                        cellSelectedHandler={this.onMaquinaSelected}
                    />

                    <div className={classes.bottomBtn}>
                        <Button variant="contained" color="secondary" className={classes.button} onClick={() => { this.props.hideDialog() }}>Cerrar</Button>
                        <Button variant="contained" color="primary" className={classes.button} disabled={!this.state.maquinaSelected} onClick={() => {
                            this.props.hideDialog();
                            this.props.okHandler(this.state.maquinaSelected);
                        }}>Seleccionar</Button>
                    </div>

                </div>
        )

    }


}

SelectMaquina.propTypes = {

    //dispatch
    hideDialog: PropTypes.func.isRequired,

    //parameters
    okHandler: PropTypes.func.isRequired,
    centroId: PropTypes.number.isRequired,
    user: PropTypes.object.isRequired

};



export default withStyles(styles, { withTheme: true })(SelectMaquina);